import { useTranslation } from 'react-i18next';

import MotifHaloOrbit from '../../Pages/EmptyState/components/MotifHaloOrbit';

interface WaitingScreenProps {
  /** supplier_manual_tasks task_type (e.g. PLAN_CHANGE_VALIDATION_IN_PROGRESS). Falls back to generic copy when absent. */
  taskType?: string;
}

const TASK_TYPE_TO_KEY: Record<string, string> = {
  PLAN_CHANGE_VALIDATION_IN_PROGRESS: 'PlanChangeValidation',
  SCOPE_EXPANSION_REVIEW_REQUIRED: 'ScopeExpansionReview',
  AVANZADO_DASHBOARD_PENDING: 'AvanzadoDashboardPending',
};

// Friendly, no-retry waiting screen for a Logyca client whose workspace is
// gated on manual work (plan-change validation, scope review, or a
// not-yet-assigned dashboard). No technical details, no action buttons —
// per Ticket 6, this must never look like an error.
const WaitingScreen = ({ taskType }: WaitingScreenProps) => {
  const { t } = useTranslation();
  const key = (taskType && TASK_TYPE_TO_KEY[taskType]) || 'Generic';

  return (
    <div className="flex w-full min-h-screen">
      <div className="m-auto flex max-w-lg flex-col items-center gap-6 px-6 text-center">
        <MotifHaloOrbit />
        <div>
          <h1 className="m-0 text-2xl font-semibold tracking-tight text-gray-900">
            {t(`Monitor.WaitingScreen.${key}.Title`)}
          </h1>
          <p className="mt-3 text-[0.95rem] leading-relaxed text-gray-500">
            {t(`Monitor.WaitingScreen.${key}.Subtitle`)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WaitingScreen;
